export default function AboutTrust() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-0">
          <div className="w-full lg:w-[55%] bg-background-50 rounded-2xl p-8 md:p-12 -mb-8 lg:-mb-0 relative z-10">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 leading-snug">
              Trusted By
              <br />
              Global
              <br />
              Sourcing Experts
            </h2>

            <div className="grid grid-cols-3 gap-6 mt-10">
              <div className="border-r border-background-200/60 pr-4">
                <div className="text-3xl md:text-4xl font-bold text-accent-500">15+</div>
                <p className="text-xs md:text-sm text-foreground-500 mt-1">Active Categories</p>
              </div>
              <div className="border-r border-background-200/60 pr-4">
                <div className="text-3xl md:text-4xl font-bold text-accent-500">500K+</div>
                <p className="text-xs md:text-sm text-foreground-500 mt-1">Products Listed</p>
              </div>
              <div>
                <div className="text-3xl md:text-4xl font-bold text-accent-500">Daily</div>
                <p className="text-xs md:text-sm text-foreground-500 mt-1">Auto Updates</p>
              </div>
            </div>

            <p className="mt-8 text-sm text-foreground-600 leading-relaxed max-w-lg">
              The <strong>acbuyspreadsheet</strong> platform aggregates sourcing data across multiple verified
              suppliers, helping buyers and resellers save hours of manual research. Our acbuy spreadsheet
              listings are cross-checked with real-time inventory feeds to ensure you always get the most
              current product information available on the market.
            </p>
          </div>

          <div className="w-full lg:w-[45%] bg-gradient-to-br from-accent-50 to-accent-100/60 rounded-2xl flex items-center justify-center p-8 md:p-12 relative overflow-hidden min-h-[280px]">
            <div className="absolute top-6 right-10 w-32 h-32 rounded-full bg-accent-200/60 opacity-70"></div>
            <div className="absolute bottom-10 left-12 w-40 h-40 rounded-full bg-accent-200/40 opacity-60"></div>
            <div className="absolute top-1/2 right-14 w-24 h-24 rounded-full bg-accent-300/30 opacity-50"></div>
            <div className="relative z-10 text-center">
              <p className="font-heading text-xl md:text-2xl text-foreground-800 italic">
                &ldquo;The most comprehensive
                <br />
                <strong>acbuy spreadsheet</strong>
                <br />
                resource available.&rdquo;
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}